// extracted by mini-css-extract-plugin
export default {"SelectInput":"radio-box-group_SelectInput__UHGuX"};